module.exports = __webpack_public_path__ + "static/shop-4b7bf5b93bc3a020bbde2f8c45c1b301.jpg";